/**
 * @generated SignedSource<<6593f3213f47a7e725f70d416f79d305>>
 * @relayHash 8a9390abebcb3e2c1af34fe271e87a0e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 35a7995000db8d19f165fbb586ae01b6e99b2295047bc3aced247c50c7b26886

import type { ConcreteRequest } from 'relay-runtime';
export type useIsLoomEntryPointsEnabledQuery$variables = {
  cloudId: string;
  includeMeetingRecorderEligibility: boolean;
};
export type useIsLoomEntryPointsEnabledQuery$data = {
  readonly confluence_loomEntryPoints: {
    readonly isLoomEntryPointsEnabled: boolean;
  } | null;
  readonly loom_connectedCalendars?: ReadonlyArray<{
    readonly guid: string;
  } | null> | null;
  readonly loom_settings?: {
    readonly meetingNotesEligible: boolean | null;
    readonly meetingRecordingsAvailable: boolean | null;
  } | null;
  readonly tenantContexts?: ReadonlyArray<{
    readonly loomEntitlementInfo: {
      readonly entitlement?: {
        readonly relatesFromEntitlements: ReadonlyArray<{
          readonly entitlementId: string | null;
          readonly relationshipId: string | null;
          readonly relationshipType: string | null;
        } | null> | null;
      } | null;
    } | null;
  } | null> | null;
};
export type useIsLoomEntryPointsEnabledQuery = {
  response: useIsLoomEntryPointsEnabledQuery$data;
  variables: useIsLoomEntryPointsEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeMeetingRecorderEligibility"
  }
],
v1 = {
  "args": [
    {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }
  ],
  "concreteType": "ConfluenceLoomEntryPoints",
  "kind": "LinkedField",
  "name": "confluence_loomEntryPoints",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isLoomEntryPointsEnabled"
    }
  ]
},
v2 = [
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "cloudId"
  }
],
v3 = {
  "args": (v2/*: any*/),
  "concreteType": "LoomSettings",
  "kind": "LinkedField",
  "name": "loom_settings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "meetingRecordingsAvailable"
    },
    {
      "kind": "ScalarField",
      "name": "meetingNotesEligible"
    }
  ]
},
v4 = {
  "args": (v2/*: any*/),
  "concreteType": "LoomConnectedCalendar",
  "kind": "LinkedField",
  "name": "loom_connectedCalendars",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "guid"
    }
  ]
},
v5 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v6 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "loom"
  }
],
v7 = {
  "concreteType": "CcpEntitlementRelationship",
  "kind": "LinkedField",
  "name": "relatesFromEntitlements",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "relationshipId"
    },
    {
      "kind": "ScalarField",
      "name": "entitlementId"
    },
    {
      "kind": "ScalarField",
      "name": "relationshipType"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsLoomEntryPointsEnabledQuery",
    "selections": [
      (v1/*: any*/),
      {
        "condition": "includeMeetingRecorderEligibility",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": (v5/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "alias": "loomEntitlementInfo",
                "args": (v6/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "CcpEntitlement",
                        "kind": "LinkedField",
                        "name": "entitlement",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/)
                        ]
                      }
                    ],
                    "type": "CommerceEntitlementInfoCcp"
                  }
                ],
                "storageKey": "entitlementInfo(hamsProductKey:\"loom\")"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsLoomEntryPointsEnabledQuery",
    "selections": [
      (v1/*: any*/),
      {
        "condition": "includeMeetingRecorderEligibility",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": (v5/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "alias": "loomEntitlementInfo",
                "args": (v6/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "CcpEntitlement",
                        "kind": "LinkedField",
                        "name": "entitlement",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ]
                      }
                    ],
                    "type": "CommerceEntitlementInfoCcp"
                  }
                ],
                "storageKey": "entitlementInfo(hamsProductKey:\"loom\")"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8a9390abebcb3e2c1af34fe271e87a0e",
    "id": "35a7995000db8d19f165fbb586ae01b6e99b2295047bc3aced247c50c7b26886",
    "metadata": {},
    "name": "useIsLoomEntryPointsEnabledQuery",
    "operationKind": "query",
    "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!,$includeMeetingRecorderEligibility:Boolean!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid}\n  tenantContexts(cloudIds:[$cloudId])@include(if:$includeMeetingRecorderEligibility){loomEntitlementInfo:entitlementInfo(hamsProductKey:\"loom\"){__typename,...on CommerceEntitlementInfoCcp{entitlement{relatesFromEntitlements{relationshipId,entitlementId,relationshipType},id}}}}}"
  }
};
})();

(node as any).hash = "5b4fce201b90479ea767c22013e8b06f";

export default node;
